// extracted by mini-css-extract-plugin
export default {"modal":"CustomModal_modal__mr43c","modalClose":"CustomModal_modalClose__WAkBx"};